var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.29134,
    y: 1.2793,
    width: 57.311,
    height: 57.5405,
    rx: 7.5,
    fill: "#13AFE0",
    fillOpacity: 0.1,
    stroke: "#13AFE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.936 10.9092C36.4211 16.3064 43.8582 16.0822 45.983 16.0822C45.5182 46.7775 42.1033 40.6538 29.936 49.1892C17.7903 40.6538 14.3756 46.7775 13.9106 16.0822C16.0134 16.0822 23.4503 16.3064 29.936 10.9092Z",
    stroke: "#13AFE0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.2b6b7f4b092bb4078f19999f2416856b.svg";
export { ForwardRef as ReactComponent };